import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageSizeService {
  stPageSize?: { [key: string]: string };
  constructor() {
    try {
      const stPageSizeTemp = localStorage.getItem('st-page-size');
      if (!stPageSizeTemp) {
        localStorage.setItem('st-page-size', JSON.stringify({ default: '10' }));
      } else {
        const pageSize = JSON.parse(stPageSizeTemp);
        if (!pageSize['default']) {
          pageSize['default'] = '10';
          localStorage.setItem('st-page-size', JSON.stringify(pageSize));
        }
      }
      this.stPageSize = JSON.parse(localStorage.getItem('st-page-size') || '{}');
    } catch (e) {
    }
  }

  setPageSize(name: string, size: number): void {
    try {
      if (this.stPageSize) {
        this.stPageSize[name] = size.toString();
      } else {
        this.stPageSize = { [name]: size.toString() };
      }
      localStorage.setItem('st-page-size', JSON.stringify(this.stPageSize));
    } catch (e) {
    }
  }

  getPageSize(name: string): number {
    try {
      if (this.stPageSize && this.stPageSize[name]) {
        return parseInt(this.stPageSize[name], 10);
      } else {
        return 10;
      }
    } catch (e) {
      return 10;
    }
  }
}
